<template>
  <section class="user-avatar" :class="[$slots.avatarAction ? 'has-action' : '', avatarSize]">
    <div v-if="isGhost">
      <div :style="`width: ${size}px; height: ${size}px;`" class="is-ghost"></div>
    </div>
    <div v-else :class="{ 'avatar-wrapper': wrapAvatar }" style="text-indent: 0 !important">
      <Avatar
        v-if="!!user?.avatarUrl"
        :src="user.avatarUrl"
        :size="size"
        :custom-class="customClass"
      />
      <GenericAvatar v-else :letters="genericLetters" :size="size" :custom-class="customClass" />

      <slot name="badge"></slot>
    </div>
    <slot name="avatarAction" v-bind="{ user }" />
  </section>
</template>

<script>
import { User } from '@/modules/user/models/User';
import Avatar from '@/modules/core/ui/components/functional/Avatar.vue';
import GenericAvatar from '@/modules/core/ui/components/functional/GenericAvatar.vue';
import { imageSizeValidator } from '@/modules/core/app/validators/SizeValidator';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'UserAvatar',
  slotsDefinition: {
    badge: {},
    avatarAction: { user: Object }
  },
  components: { Avatar, GenericAvatar },
  props: {
    user: [User, Object],
    letters: { type: String },
    size: { type: String, default: '32' },
    wrapAvatar: { type: Boolean, default: false },
    avatarSize: {
      type: String,
      validator: imageSizeValidator
    },
    isGhost: { type: Boolean, default: false }
  },
  computed: {
    genericLetters() {
      return this.letters ?? this.user?.avatarLetters ?? '';
    },
    customClass() {
      return this.user?.deletedAt ? 'is-grayscale' : undefined;
    }
  }
};
</script>

<style scoped>
:deep(.badge) {
  position: absolute;
  left: 0;
  right: 0;
  bottom: var(--ce--3px);
  width: var(--ce-19px);
  margin-inline: auto;
}

.user-avatar {
  padding: var(--ce-1px);

  &.tiny {
    .image,
    :deep(figure) {
      width: var(--ce-20px) !important;
      height: var(--ce-20px) !important;
      max-width: var(--ce-20px) !important;
      min-width: var(--ce-20px) !important;

      div span {
        font-size: calc(var(--ce-20px) / 2.6) !important;
      }
    }
  }

  &.small {
    .image,
    :deep(figure) {
      width: var(--ce-25px) !important;
      height: var(--ce-25px) !important;
      max-width: var(--ce-25px) !important;
      min-width: var(--ce-25px) !important;

      div span {
        font-size: calc(var(--ce-25px) / 2.6) !important;
      }
    }
  }

  &.medium {
    .image,
    :deep(figure) {
      width: var(--ce-30px) !important;
      height: var(--ce-30px) !important;
      max-width: var(--ce-30px) !important;
      min-width: var(--ce-30px) !important;

      div span {
        font-size: calc(var(--ce-30px) / 2.6) !important;
      }
    }
  }

  &.large {
    .image,
    :deep(figure) {
      width: var(--ce-32px) !important;
      height: var(--ce-32px) !important;
      max-width: var(--ce-32px) !important;
      min-width: var(--ce-32px) !important;

      div span {
        font-size: calc(var(--ce-32px) / 2.6) !important;
      }
    }
  }
}

.avatar-wrapper {
  position: relative;
  padding: var(--ce-2px);
  border-radius: 50%;
  background: var(--ce-primary);

  img {
    position: absolute;
  }

  .image {
    display: block;
  }
}

.is-ghost {
  border-radius: 50%;
  background-color: var(--ce-grey-lightest);
  border: var(--ce-2px) dashed var(--ce-grey-lighter);
}
</style>
